var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_30024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.174 0.745367C14.8739 0.26307 13.4679 -0.000976556 12.0001 -0.000976556C10.5322 -0.00102343 9.12618 0.26307 7.8262 0.745367L6.78271 11.999L7.8262 23.2526C9.12614 23.735 10.5322 23.999 12.0001 23.999C13.4679 23.999 14.874 23.735 16.174 23.2526L17.2174 11.999L16.174 0.745367Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 11.9995C23.9999 6.83993 20.7434 2.44132 16.1738 0.74585V23.2532C20.7434 21.5575 23.9999 17.1591 23.9999 11.9995Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9994C0 17.159 3.2565 21.5575 7.82602 23.2531L7.82606 0.74585C3.2565 2.44132 0 6.83979 0 11.9994Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_30024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRo);
export default __webpack_public_path__ + "static/media/RO.f51423e289241179c370431a3a4c640b.svg";
export { ForwardRef as ReactComponent };